import React from "react";
import AppTemplate from "../components/PlanSelectComplete";

const PlanSelectComplete: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default PlanSelectComplete;
